import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BackendInfoService {

  constructor() { }

  public static backendIsLocalTest(): boolean {
    return environment.apiBasepoint.includes('item-sharing-web-backend');
  }
}
